module.exports = __webpack_public_path__ + "img/1-1.4c642d43.png";